module.exports = __webpack_public_path__ + "static/media/mstable.c3c3af93.svg";